import { JsonProperty } from "../../../models/utilities/json-property";
import { LocalTimeRead } from "../../../models/utilities/local-time-read";
import { ShipmentType } from "../enums/_index";
import { ShipmentStatus } from "../enums/shipment-status";

export class ShipmentSummary {

    public id : number = 0;

    public type : ShipmentType;

    public name: string = '';

    public driverName: string = '';
    
    public status : ShipmentStatus = ShipmentStatus.Open;
    
    public serviceCenterId : string = '';
    
    @JsonProperty({ toClass: LocalTimeRead })
    public departureTime : LocalTimeRead = new LocalTimeRead();
    
    @JsonProperty({ toClass: LocalTimeRead })
    public returnTime : LocalTimeRead = new LocalTimeRead();
    
    @JsonProperty({ toType: 'date' })
    public cutoffDate : Date|undefined = undefined;

    @JsonProperty({ toType: 'datetime' })
    public createdOn : Date|undefined = undefined;
    
    @JsonProperty({ toType: 'datetime' })
    public lastModified : Date|undefined = undefined;
    
    public rowVersion : string = '';

    // UI Properties
    public isChecked : boolean = false;
    
    constructor(type : ShipmentType) {
        this.type = type;
    }
    
}
